<template>
    <div>
        <div v-if="(userConnected && bookData.is_editable) || userCreator"
             class="row add-address-section sticky-top py-1 mb-3">
            <div class="col-12 edit-book-menu d-flex flex-column flex-md-row align-items-center justify-content-evenly">
                <a class="d-block h3-like fs-5 fs-lg-4 text-center mb-0 py-1 text-decoration-none text-white"
                   data-bs-toggle="modal" data-bs-target="#addAddress" @click="getLatestReviews()">
                    <span class="icon add-address"></span>
                    Ajouter une adresse
                </a>

                <a v-if="userCreator" href="" @click.prevent="edit(); update();"
                   class="d-block h3-like fs-5 fs-lg-4 text-center mb-0 py-1 text-decoration-none">
                    <span class="icon edit"></span>
                    {{ draggable || deletable ? 'Valider les modifications' : 'Modifier / Réorganiser le carnet' }}
                </a>

                <a v-if="userCreator" href="" class="d-block h3-like fs-5 fs-lg-4 text-center mb-0 py-1 text-decoration-none"
                   @click.prevent="addBlockText('legend')">
                    <span class="icon edit"></span>
                    Ajouter un bloc texte
                </a>
            </div>
        </div>

        <div v-else class="row add-address-section sticky-top py-1 mb-3">
            <div class="col-12 edit-book-menu d-flex flex-column flex-md-row align-items-center justify-content-evenly">
                <a class="d-block h3-like fs-5 fs-lg-4 text-center mb-0 py-1 text-decoration-none text-white"
                   data-bs-toggle="modal" data-bs-target="#connexion">
                    <span class="icon add-address"></span>
                    Ajouter une adresse
                </a>
            </div>
        </div>

        <div v-if="editionSave.length" class="alert alert-success fade show">
            {{ editionSave }}
        </div>

        <div v-if="(userConnected && bookData.is_editable) || userCreator" class="modal fade" id="addAddress"
             tabindex="-1" aria-labelledby="addAddress" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-centered">
                <div class="modal-content modal-block">
                    <div class="modal-close-button box-shadow">
                        <button type="button" class="btn-close btn-close-white p-2" data-bs-dismiss="modal"
                                aria-label="Close"></button>
                    </div>

                    <div class="modal-body modal-block-content mx-auto box-shadow position-relative">
                        <div class="line line-left">
                            <h3 class="h2-like bg-white-like">Trouvez une adresse à ajouter à ce carnet</h3>
                        </div>

                        <div class="px-sm-5 pt-4 pb-2 pt-md-3 mb-5 header-width search-form bg-darkRed">
                            <form action="#" @submit.prevent="search($event)"
                                  class="d-flex flex-wrap flex-column flex-lg-row justify-content-lg-center align-items-center launch-search-form">
                                <div
                                    class="col-12 col-lg-5 col-xl-4 d-flex flex-column flex-lg-row search-input-block pe-2 pb-2">
                                    <label for="what" class="my-auto search-label">Quoi&nbsp;?</label>
                                    <div class="d-flex flex-row">
                                        <auto-complete-component
                                            type="what"
                                            id="whatBook"
                                            name="whatBook"
                                            placeholder="Activité, nom, mots-clés"
                                            :old-value="what"
                                            :reset="reset"
                                        ></auto-complete-component>
                                        <modal-categories-component :id="idModal" :book="true">
                                        </modal-categories-component>
                                    </div>
                                </div>

                                <div
                                    class="col-12 col-lg-5 col-xl-4 d-flex flex-column flex-lg-row search-input-block ms-lg-2 pe-2 pb-2">
                                    <label for="where" class="my-auto ml-0 ml-md-5 search-label">Où&nbsp;?</label>
                                    <div class="d-flex flex-row">
                                        <auto-complete-component
                                            type="where"
                                            id="whereBook"
                                            name="whereBook"
                                            placeholder="Ville, code postal, département, métro"
                                            old-value=""
                                            :reset="reset"
                                            class="minw-250px"
                                        ></auto-complete-component>
                                        <button type="submit" class="bg-teal search-button search-button me-1">
                                            <svg width="16" heigth="16" fill="currentColor"
                                                 xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
                                                 class="text-white">
                                                <path
                                                    d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"></path>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </form>
                            <p v-if="searchError.error" class=" text-white text-center mb-0" v-html="searchError.message"></p>
                        </div>

                        <div v-if="searchedPois.length">
                            <p class="fs-4 fw-light mb-4">Choisissez parmi les commerces suivants :</p>

                            <div v-for="searchedPoi of searchedPois" :key="searchedPoi.id"
                                 class="d-flex align-items-center justify-content-between px-2 mb-4">
                                <div>
                                    <p class="mb-0">{{ searchedPoi.nameCleaned }}, {{ searchedPoi.city.postal_code }}
                                        {{ searchedPoi.city.name }}</p>
                                    <div class="d-flex align-items-center mb-0 poi-review-stars">
                                        <div>{{ searchedPoi.number_of_notes }} avis,</div>
                                        <div class="review-content-stars ms-3">
                                            <div class="review-content-stars-mark"
                                                 :style="'width:'+searchedPoi.average*20+'%'">
                                                <img src="/images/star-system--small.png"
                                                     :alt="searchedPoi.average+' sur 5'"
                                                     :title="searchedPoi.average+' sur 5'">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <a href="#"
                                   @click.prevent="searchedPoi.inBook ? null : storePoiToBook(searchedPoi.id, 'searched')"
                                   :class="searchedPoi.inBook ? 'fw-bold inactive-link' : null">{{
                                        searchedPoi.inBook ? 'Sélectionné' : 'Sélectionner'
                                    }}</a>
                            </div>

                            <div class="mx-auto">
                                <ul v-if="searchPagination"
                                    class="d-flex align-items-stretch justify-content-center pagination-wrapper">
                                    <template v-for="(link, index) of searchPagination">
                                        <li v-if="index <= 5 || index >= searchPagination.length - 4 || searchPage === parseInt(link.label)"
                                            class="d-flex align-items-center text-center p-2 pagination"
                                            :class="searchPage === parseInt(link.label) ? 'active' : '' "
                                            @click.prevent="search($event, link.label)">
                                            <span v-if="link.label.includes('Previous')"
                                                  v-html="link.label.replace('Previous', 'Préc.')"></span>
                                            <span v-else-if="link.label.includes('Next')"
                                                  v-html="link.label.replace('Next', 'Suiv.')"></span>
                                            <span v-else v-html="link.label"></span>
                                        </li>
                                    </template>
                                </ul>
                            </div>
                        </div>

                        <div v-if="searchedPoisError.error" class="text-center mb-4" v-html="searchedPoisError.message"></div>

                        <div v-if="searchInProgress" class="spinner-border d-flex mx-auto text-danger text-center my-4"
                             role="status">
                            <span class="visually-hidden">Chargement en cours...</span>
                        </div>

                        <div v-if="reviewedPois.length > 0 && searchedPois.length === 0">
                            <p class="fs-4 fw-light mb-4">Ou choisissez parmi vos derniers avis :</p>

                            <div v-if="showSuccessAdding" class="bg-teal text-white p-2 mb-4" v-html="showSuccessAdding"></div>

                            <div v-for="reviewedPoi of reviewedPois" :key="reviewedPoi.id"
                                 class="d-flex align-items-center justify-content-between px-2 mb-4">
                                <div>
                                    <p class="mb-0">{{ reviewedPoi.nameCleaned }}, {{ reviewedPoi.city.postal_code }}
                                        {{ reviewedPoi.city.name }}</p>
                                    <div class="d-flex align-items-center mb-0 poi-review-stars">
                                        <div>{{ reviewedPoi.number_of_notes }} avis,</div>
                                        <div class="review-content-stars ms-3">
                                            <div class="review-content-stars-mark"
                                                 :style="'width:'+reviewedPoi.average*20+'%'">
                                                <img src="/images/star-system--small.png"
                                                     :alt="reviewedPoi.average+' sur 5'"
                                                     :title="reviewedPoi.average+' sur 5'">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <button type="button"
                                        @click.prevent="!isSelected(reviewedPoi) ? storePoiToBook(reviewedPoi.id) : ''"
                                        :class="(isSelected(reviewedPoi) ? 'fw-bold inactive-link' : '') +  ' btn btn-link link-like'">
                                    {{ isSelected(reviewedPoi) ? 'Sélectionné' : 'Sélectionner' }}
                                </button>
                            </div>
                        </div>

                        <div v-if="reviewedPoisNotFound.length" v-html="reviewedPoisNotFound"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row book-poi-list" ref="list">
            <grid-layout
                @breakpoint-changed="breakpointChangedEvent"
                :layout.sync="cardsListFiltered"
                :col-num="3"
                :is-draggable="draggable"
                :is-resizable="resizable"
                :vertical-compact="true"
                :responsive="true"
                :prevent-collision="false"
                :breakpoints="{lg: 1200, md:1000, sm: 768, xs:480, xxs :0}"
                :cols="{lg : 3, md: 3, sm : 2, xs:1, xxs:1}"
                :use-css-transforms="true"
            >
                <grid-item v-for="card in cardsListFiltered"
                           :class="draggable ? 'draggable-outline' : ''"
                           class="bg-main"
                           :static="card.static"
                           :x="card.x"
                           :y="card.y"
                           :w="card.w"
                           :h="card.h"
                           :i="card.i"
                           :key="card.i"
                           @moved="moved">
                    <div v-if="draggable" class="cardMove"></div>

                    <!-- MAP CARD -->
                    <div v-if="card.is_map || card.map" class="d-flex flex-column p-3">
                        <map-component :pois="pois" :zoom="7" :draggable="false"></map-component>
                    </div>

                    <!-- POI CARD -->
                    <div v-if="card.poi" class="d-flex flex-column justify-content-start p-3 h-100">
                        <a :href="card.poi.link" :title="card.poi.nameCleaned" class="align-self-center">
                            <img :src="card.poi.picture" :alt="card.poi.nameCleaned"
                                 :class="card.poi.picture.includes('subcategories') ? 'width-150 margin-50 mx-auto' : 'book-main-image'">
                        </a>

                        <h2 class="h3-like fw-normal mb-0 mt-5"><a :href="card.poi.link" :title="card.poi.nameCleaned" v-html="card.poi.nameCleaned"></a></h2>

                        <p class="darkgrey mb-0 mt-2">{{ card.poi.address }} - {{ card.poi.city.postal_code }} {{ card.poi.city.name }}</p>

                        <div class="d-flex align-items-center mb-0 mt-2 poi-review-stars">
                            <p class="mb-0 fw-bold darkred">{{ card.poi.number_of_notes }} avis</p>

                            <div class="review-content-stars ms-3">
                                <div class="review-content-stars-mark" :style="'width:'+card.poi.average*20+'%'">
                                    <img src="/images/star-system--small.png" :alt="card.poi.average+' sur 5'"
                                         :title="card.poi.average+' sur 5'">
                                </div>
                            </div>
                        </div>

                        <p v-if="card.poi.review" class="lh-sm mb-0">«<span
                            v-html="card.poi.review.description.substring(0, 140)"></span>...»</p>

                        <div class="d-flex justify-content-between align-items-center mt-4">
                            <p class="mb-0 position-relative">
                                <user-popin-component :unique-id="'unique-' + Math.floor(Math.random() * 100000)"
                                                      :user-id="card.poi.addingUser.id">
                                    Ajouté par <a :href="card.poi.addingUser.link"
                                                  class="d-inline-block text-capitalize" v-html="card.poi.addingUser.name"></a>
                                </user-popin-component>
                            </p>

                            <a v-if="(userConnected && bookData.is_editable && deletable) || (userCreator && deletable) || !userCreator && card.poi.addingUser.id === userId"
                               class="delete-icon teal" @click.prevent="deleteContent(card.id)"></a>
                        </div>
                    </div>

                    <!-- LEGEND CARD-->
                    <form v-if="card.legend && card.editing" :class="'card-' + card.i"
                          class="d-flex flex-column p-3 bg-main" @submit.prevent="validateText(card)">
                        <a class="d-block delete-icon teal ms-auto" @click.prevent="deleteCard(card.i)"></a>

                        <textarea rows="8"
                                  placeholder="Racontez votre expérience, enrichissez votre carnet avec une anecdote, un conseil..."
                                  class="add-block-text-textarea" v-model="card.legend.content"
                                  name="content"></textarea>
                        <p v-if="card.alertContent" class="darkred text-center mt-2">Votre message ne peut pas être vide !</p>
                        <p v-if="errorStoreBookLegend.length" class="darkred text-center mt-2" v-html="errorStoreBookLegend"></p>
                        <input class="btn btn-red" type="submit" value="Valider">
                    </form>

                    <div v-if="card.legend && !card.editing" class="d-flex flex-column p-3 bg-main text-break">
                        <p class="mb-0">{{ card.legend.content }}</p>
                        <div class="align-self-end">
                            <a v-if="(userConnected && bookData.is_editable && deletable) || (userCreator && deletable)"
                               class="d-block delete-icon teal text-end" @click.prevent="deleteContent(card.id)"></a>
                        </div>
                    </div>
                </grid-item>
            </grid-layout>
        </div>
    </div>
</template>

<script>
import {GridLayout, GridItem} from "vue-grid-layout"

export default {
    components: {
        GridLayout,
        GridItem,
    },

    props: {
        bookData: Object,
        bookInfo: Array,
        userCreator: Boolean,
        userConnected: Boolean,
        userId: Number,
        visibleCriterias: {
            type: Array,
            required: false
        }
    },

    data() {
        return {
            abortController: null,
            cardsList: [],
            cardsListFiltered: [],
            breakPoint: null,
            draggable: false,
            deletable: false,
            editionSave: '',
            errorStoreBookLegend: '',
            idModal: Date.now(),
            isStoring: false,
            listUpdated: true,
            newLegendCard: {
                legend: {
                    content: '',
                },
                editing: true,
                alertContent: false,
                h: 2,
                w: 1,
                y: 0,
                x: 0,
            },
            pois: {},
            reset: false,
            resizable: false,
            reviewedPois: [],
            reviewedPoisNotFound: '',
            showSuccessAdding: '',
            searchedPois: [],
            searchedPoisError: {
                error: false,
                message: 'Il ne semble pas y avoir de résultat correspondant à votre recherche.'
            },
            searchError: {
                error: false,
                message: 'Il y a une erreur avec votre recherche. Vous devez renseigner un lieu.'
            },
            searchInProgress: false,
            searchPagination: null,
            searchPage: null,
            where: null,
            what: null,
        }
    },

    mounted() {
        this.cardsList = this.bookInfo;
        this.generateCardList();
    },

    watch: {
        visibleCriterias: function (newVal) {
            this.generateCardList(newVal);
        }
    },

    computed: {},

    methods: {
        addBlockText(element) {
            this.$parent.visibleCriterias = [];

            this.$nextTick(() => {
                if (element === 'legend') {
                    if (this.draggable) {
                        this.edit();
                    }

                    let position = 0;
                    let x = 0;
                    let y = 0;
                    let elementByX = [
                        {
                            x: 0,
                            y: 0
                        },
                        {
                            x: 0,
                            y: 0
                        },
                        {
                            x: 0,
                            y: 0
                        },
                    ];

                    if (this.cardsList.length) {
                        let sortByPosition = this.cardsList.sort((a, b) => b.i - a.i);
                        position = sortByPosition[0].i + 1;

                        sortByPosition.forEach(element => {
                            if (element.x === 0) {
                                elementByX["0"].x++;
                            } else if (element.x === 1) {
                                elementByX["1"].x++;
                            } else if (element.x === 2) {
                                elementByX["2"].x++;
                            }
                        });
                        x = elementByX.reduce((minIdx, current, idx, arr) => {
                            return current.x < arr[minIdx].x ? idx : minIdx;
                        }, 0);
                        sortByPosition = sortByPosition.sort((a, b) => b.y - a.y);
                        y = sortByPosition[0].y + 1;
                    }
                    this.newLegendCard.i = position;
                    this.newLegendCard.x = x;
                    this.newLegendCard.y = y;
                    this.cardsList.push(this.newLegendCard);
                    this.generateCardList();

                    this.$nextTick(() => {
                        const classId = '.card-' + position.toString();
                        const newCardElement = document.querySelector(classId);
                        if (newCardElement) {
                            newCardElement.scrollIntoView({behavior: 'smooth', block: 'center'});
                        }
                    })
                }
            })
        },

        breakpointChangedEvent(newBreakpoint, newLayout) {
            this.breakPoint = newBreakpoint;
            this.checkDraggable();
        },

        edit() {
            this.draggable = !this.draggable;
            this.deletable = !this.deletable;
            if (this.draggable) {
                this.$parent.visibleCriterias = [];
            }
            this.checkDraggable();
            this.listUpdated = !this.listUpdated;
        },

        deleteCard(i) {
            let index = this.cardsList.findIndex(card => card.i === i);
            if (index !== -1) {
                this.cardsList.splice(index, 1);
                this.generateCardList();
            }
        },

        deleteContent(id) {
            axios.delete('/api/v1/bookInformation/' + id + '/delete')
                .then(() => {
                    let index = this.cardsList.findIndex(card => card.id === id);
                    if (index !== -1) {
                        this.cardsList.splice(index, 1);
                    }
                })
                .then(() => {
                    this.generateCardList();
                })
                .catch((error) => {
                    console.log(error);
                })
        },

        generateCardList(types = null) {
            this.cardsListFiltered = [];

            for (let item of this.cardsList) {
                if (types && types.length > 0) {
                    if (item.poi !== null) {
                        types.forEach(type => {
                            if (type.type === 'city' || type.type === 'department') {
                                if (type.name === item.poi.city.name || type.name === item.poi.department.name) {
                                    this.cardsListFiltered.push(item);
                                    this.cardsListFiltered = this.cardsListFiltered.filter((card, index, self) => {
                                        return index === self.findIndex(c => c.poi === card.poi);
                                    });
                                }
                            } else {
                                const filter = item.poi.subcategoriesNames.find(category => category === type.name);
                                if (filter) {
                                    this.cardsListFiltered.push(item);
                                    this.cardsListFiltered = this.cardsListFiltered.filter((card, index, self) => {
                                        return index === self.findIndex(c => c.poi === card.poi);
                                    });
                                }
                            }
                        });
                    }
                } else {
                    if (item.poi || item.legend || item.map) {
                        this.cardsListFiltered.push(item);
                    }
                }
            }

            if (types && types.length > 0) {
                let y = 0;
                let x = 0;
                this.cardsListFiltered.forEach(card => {
                    card.x = x;
                    card.y = y;
                    y = (x > 1 ? y + 1 : y = 0);
                    x = (x > 1 ? x = 0 : x + 1);
                });
            }
            this.pois = this.cardsListFiltered.filter(card => (card.poi));
        },

        getLatestReviews() {
            this.$parent.visibleCriterias = [];
            if (this.draggable) {
                this.edit();
                if(this.listUpdated) {
                    this.update();
                }
            }

            axios.get('/api/v1/pois/reviewed')
                .then((response) => {
                    if (response.data) {
                        this.reviewedPois = response.data;
                        this.reviewedPoisNotFound = '';
                    }
                })
                .catch((error) => {
                    this.reviewedPoisNotFound = error.response.data;
                });
        },

        checkDraggable() {
            if (this.breakPoint === 'xxs' || this.breakPoint === 'xs' || this.breakPoint === 'sm') {
                this.draggable = false;
            }
        },

        isSelected(reviewedPoi) {
            if (reviewedPoi.book_informations.length) {
                let isAlreadyInBook = reviewedPoi.book_informations.filter(bookInformation => bookInformation.book_id === this.bookData.id);
                if (isAlreadyInBook.length) {
                    return true;
                }
            }
            return false;
        },

        insertMap(map) {
            map.i = map.position;
            this.cardsList.push(map);
        },

        search(event, page = false) {
            const url = '/api/v1/pois/search/';

            this.searchError.error = false;
            this.searchInProgress = true;

            if (!page) {
                const data = new FormData(event.target);
                this.what = data.getAll('whatBook')[0];
                this.where = data.getAll('whereBook')[0];
            } else {
                if (page.includes('Précédent') && this.searchPage > 1) {
                    page = this.searchPage - 1;
                } else if (page.includes('Suivant')) {
                    if (this.searchPage < Number(this.searchPagination[this.searchPagination.length - 2].label)) {
                        page = this.searchPage + 1;
                    } else {
                        page = this.searchPage;
                    }
                }
            }

            if (this.abortController) {
                this.abortController.abort();
            }

            this.abortController = new AbortController();

            if (this.where !== undefined && this.where !== '') {
                this.searchedPois = [];

                axios.get(
                    url, {
                        params: {
                            what: this.what,
                            where: this.where,
                            page: page
                        },
                        signal: this.abortController.signal
                    })
                    .then((response) => {
                        this.searchInProgress = false;
                        if (response.data.total) {
                            this.searchedPoisError.error = false;
                            this.searchedPois = response.data.data;
                            this.searchPagination = response.data.links;
                            this.searchPage = response.data.current_page;
                            this.matchDataWithBook(this.searchedPois);
                            this.reset = true;
                        } else {
                            this.searchedPoisError.error = true;
                            this.searchedPoisError.message = response.data.message;
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    })
                    .finally(() => {
                        this.reset = true;
                    });
            } else {
                this.searchInProgress = false;
                this.searchError.error = true;
            }
        },

        matchDataWithBook(data) {
            for (let item of data) {
                item.inBook = false

                for (let card of this.cardsList) {
                    if (card.poi && card.poi.id === item.id) {
                        item.inBook = true
                    }
                }
            }
        },

        storePoiToBook(poiId) {
            axios.post('/api/v1/bookInformation/' + this.bookData.id + '/' + poiId + '/store')
                .then((response) => {
                    if (response.data) {
                        if (response.data.map) {
                            this.insertMap(response.data.map);
                        }

                        if (response.data.element && response.data.element.informations) {
                            this.cardsList.push(response.data.element.informations);
                            this.pois = this.cardsList.filter(card => card.poi);
                            this.generateCardList();
                        }

                        this.showSuccessAdding = response.data.element.message;
                        setTimeout(() => this.showSuccessAdding = '', 3000);
                        this.getLatestReviews();

                        let poi = this.searchedPois.find(poi => poi.id === poiId);
                        if (poi) {
                            poi.inBook = true;
                        }
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
        },

        storeBookLegend(card) {
            axios.post('/api/v1/bookLegend/' + this.bookData.id + '/store', {card: card})
                .then((response) => {
                    if (response && response.data && response.data.element) {
                        card.id = response.data.element.id;
                        card.editing = false;

                        let index = this.cardsList.findIndex(c => c.id === card.id);
                        if (index !== -1) {
                            this.cardsList.splice(index, 1);
                            this.cardsList.push(card);
                        }

                        if (response.data.map) {
                            this.insertMap(response.data.map)
                        }

                        this.newLegendCard = Object.assign({}, {
                            legend: {
                                content: '',
                            },
                            editing: true,
                            alertContent: false,
                            h: 2,
                            w: 1,
                            y: 0,
                            x: 0
                        });
                    }
                })
                .catch((error) => {
                    if (error.response && error.response.data && error.response.data.message) {
                        this.errorStoreBookLegend = error.response.data.message;
                        card.editing = true;
                        setTimeout(() => {
                            this.errorStoreBookLegend = '';
                        }, 3500);
                    }
                });
        },

        moved(i, newX, newY, oldX, oldY) {
            this.$forceUpdate();
        },

        async update() {
            if (this.listUpdated) {
                axios.patch(
                    '/api/v1/bookInformation/' + this.bookData.id + '/update', {
                        card: this.cardsListFiltered
                    }).then(response => {
                        this.cardsList = this.cardsListFiltered;
                })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },

        validateText(card) {
            let index = this.cardsList.findIndex(c => c.i === card.i);
            if (card.legend.content.length) {
                card.alertContent = false;
                let height = Math.round(card.legend.content.length / 150 / 2);
                card.h = height <= 0 ? 1 : height + 1;
                this.storeBookLegend(card);
            } else {
                card.alertContent = true;
            }
        },
    },
};
</script>
